import { FromSchema, Country, EnumSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const AiprizeRelatedCompanySchema = z
    .object({
        name: z.string().optional(),
        country: EnumSchema(Country).optional(),
        description: z.string().optional(),
        addresses: z.array(z.string()).optional(),
        relationship: z.string().optional(),
        companyId: z.string().optional(),
    })
    .strict();

export class AiprizeRelatedCompany extends FromSchema(AiprizeRelatedCompanySchema) {
    name?: string;
    country?: Country;
    description?: string;
    addresses?: string[];
    relationship?: string;
    companyId?: string;
}
